import { render, staticRenderFns } from "./personalWait.vue?vue&type=template&id=b18d0d3e&scoped=true"
import script from "./personalWait.vue?vue&type=script&lang=js"
export * from "./personalWait.vue?vue&type=script&lang=js"
import style0 from "./personalWait.vue?vue&type=style&index=0&id=b18d0d3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18d0d3e",
  null
  
)

export default component.exports